import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { chatService } from '../../services/api'
import { Chat } from '../../models/Chat.model'

const initialState = {
  messages: {},
  loading: false,
  error: null
}

export const fetchMessages = createAsyncThunk(
  'chat/fetchMessages',
  async (caseId, { rejectWithValue }) => {
    try {
      const response = await chatService.getMessages(caseId)
      return {
        caseId,
        messages: response.data.messages.map(m => Chat.FromObj(m))
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch messages')
    }
  }
)

export const sendMessage = createAsyncThunk(
  'chat/sendMessage',
  async ({ caseId, message }, { rejectWithValue }) => {
    try {
      const response = await chatService.sendMessage(caseId, message)
      return {
        caseId,
        message: Chat.FromObj(response.data)
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to send message')
    }
  }
)

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    addMessage: (state, action) => {
      const { caseId, message } = action.payload
      if (!state.messages[caseId]) {
        state.messages[caseId] = []
      }
      state.messages[caseId].push(Chat.FromObj(message))
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessages.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.loading = false
        const { caseId, messages } = action.payload
        state.messages[caseId] = messages
      })
      .addCase(fetchMessages.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      .addCase(sendMessage.fulfilled, (state, action) => {
        const { caseId, message } = action.payload
        if (!state.messages[caseId]) {
          state.messages[caseId] = []
        }
        state.messages[caseId].push(message)
      })
  }
})

export const { clearError, addMessage } = chatSlice.actions
export const selectMessages = (state) => state.chat.messages
export const selectChatLoading = (state) => state.chat.loading
export const selectChatError = (state) => state.chat.error
export const selectMessagesByCase = (caseId) => (state) => state.chat.messages[caseId] || []

export default chatSlice.reducer 